import Footer from 'ui/snippets/footer/Footer';
import TopRow from 'ui/snippets/topBar/TopBar';

import Container from './Container';
import Content from './Content';
import MainArea from './MainArea';
import MainAreaTop from './MainAreaTop';
import MainColumn from './MainColumn';
import NavBar from './NavBar';
import SideBar from './SideBar';

export {
  Container,
  Content,
  MainArea,
  MainAreaTop,
  SideBar,
  NavBar,
  MainColumn,
  Footer,
  TopRow,
};

// Container
//    TopRow
//    MainArea
//       SideBar
//       MainColumn
//          Content
//    Footer
